<template>
	<section id="businessNote">
    <div class="container">
      <div class="header">
        <h5>Business</h5>
        <CancelButton></CancelButton>
      </div>
      <div class="businessNoteWrapper">
        <div class="note column is-two-thirds has-text-centered b2bNotes">
          <p><b>Please Note:</b><br>
          To complete your loyalty card sign-up, you are required to provide your company registration number or ID for verification purposes. This information is necessary to finalise your membership and ensure your eligibility for our program benefits. Your details will be kept confidential in accordance with our privacy policy. </p>
        </div>
      </div>
      <div class="actions">
        <button @click="back()" class="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toBusinessContactInfo()" class="button is-danger">Continue</button>
      </div>
    </div>
	</section>
</template>

<script>
import CancelButton from "../../components/actions/CancelButton";
export default {
  name: "businessDisclaimer",
  components: {
    CancelButton
  },
  methods: {
    toBusinessContactInfo() {
          this.$router.push("/businessInfo");

    },

    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    },
}
};
</script>